/* Craftmark NFPA builder (snippets/cm-nfpa-builder.liquid). Product setup is in custom.buy_config ("builder":"nfpa"):
   - nf.diamond: custom NFPA 704 hazard diamond sign. Adds the four rating fields, draws the diamond live,
     shows the viewing distance for the size picked and saves a picture of the sign with the cart line.
   - nf.note: shows a required wording box when an option is set to a given value (custom tags). */
(function () {
  'use strict';
  var cfgEl = document.getElementById('cm-nf-cfg'); if (!cfgEl) return;
  var cfg = {}; try { cfg = (JSON.parse(cfgEl.textContent) || {}).nf || {}; } catch (e) {}
  var NS = 'http://www.w3.org/2000/svg', svg = document.getElementById('cm_nf_svg');
  function el(n, a, p) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); if (p) p.appendChild(e); return e; }
  function $(id) { return document.getElementById(id); }
  function form() { return $('custom_product_form') || document.querySelector('form[data-type="add-to-cart-form"]'); }
  function optSel(label) { var s = null; [].forEach.call(document.querySelectorAll('.product_option_select'), function (x) { if (x.getAttribute('data-option-label') === label) s = x; }); return s; }
  function row(label, inner, cls) {
    var d = document.createElement('div'); d.className = 'product_variation_field row mb-4 align-items-center' + (cls ? ' ' + cls : '');
    d.innerHTML = '<div class="label_col col-2"><label>' + label + '</label></div><div class="field_col col-10">' + inner + '</div>';
    return d;
  }
  function anchor() { var q = $('qty_input'); return q ? q.closest('.product_variation_field') : null; }
  function setProp(name, val) {
    var f = form(); if (!f) return;
    var e = f.querySelector('input[type=hidden][name="properties[' + name + ']"]');
    if (!val && val !== 0) { if (e) e.remove(); return; }
    if (!e) { e = document.createElement('input'); e.type = 'hidden'; e.name = 'properties[' + name + ']'; f.appendChild(e); }
    e.value = val;
  }

  // ---------------- custom diamond ----------------
  var H = ['0 – Normal material', '1 – Slightly hazardous', '2 – Hazardous', '3 – Extreme danger', '4 – Deadly'];
  var F = ['0 – Will not burn', '1 – Flash point above 200°F', '2 – Flash point below 200°F', '3 – Flash point below 100°F', '4 – Flash point below 73°F'];
  var I = ['0 – Stable', '1 – Unstable if heated', '2 – Violent chemical change', '3 – Shock and heat may detonate', '4 – May detonate'];
  var S = [['', 'None (leave blank)'], ['OX', 'OX – Oxidizer'], ['SA', 'SA – Simple asphyxiant gas'], ['W', 'W – Reacts with water (use no water)'], ['ACID', 'ACID – Acid'], ['ALK', 'ALK – Alkali'], ['BIO', 'BIO – Biohazard'], ['COR', 'COR – Corrosive'], ['CRYO', 'CRYO – Cryogenic'], ['POI', 'POI – Poison'], ['RAD', 'Radiation hazard symbol']];
  function opts(a, sel) { return a.map(function (t, i) { return '<option value="' + i + '"' + (i === sel ? ' selected' : '') + '>' + t + '</option>'; }).join(''); }
  function buildDiamond() {
    var a = anchor(); if (!a) return false;
    var nodes = [
      row('Health (blue)', '<select id="nf_h">' + opts(H, 2) + '</select>'),
      row('Flammability (red)', '<select id="nf_f">' + opts(F, 2) + '</select>'),
      row('Instability (yellow)', '<select id="nf_i">' + opts(I, 0) + '</select>'),
      row('Special (white)', '<select id="nf_s">' + S.map(function (s) { return '<option value="' + s[0] + '">' + s[1] + '</option>'; }).join('') + '</select>')
    ];
    nodes.forEach(function (n) { a.parentElement.insertBefore(n, a); });
    var ms = optSel('Material');
    if (cfg.sibling && ms) { var l = document.createElement('div'); l.className = 'cm-nf-sib'; l.innerHTML = '<a href="' + cfg.sibling.url + '">' + cfg.sibling.label + ' &rarr;</a>'; ms.parentElement.appendChild(l); }
    return true;
  }
  function cur() { return { h: ($('nf_h') || {}).value || '0', f: ($('nf_f') || {}).value || '0', i: ($('nf_i') || {}).value || '0', s: ($('nf_s') || {}).value || '' }; }
  function trefoil(g, cx, cy, r) {
    el('circle', { cx: cx, cy: cy, r: r * .2, fill: '#111' }, g);
    for (var k = 0; k < 3; k++) {
      var a0 = (-90 - 30 + k * 120) * Math.PI / 180, a1 = (-90 + 30 + k * 120) * Math.PI / 180, ri = r * .32;
      var d = 'M' + (cx + ri * Math.cos(a0)) + ' ' + (cy + ri * Math.sin(a0)) + 'L' + (cx + r * Math.cos(a0)) + ' ' + (cy + r * Math.sin(a0)) + 'A' + r + ' ' + r + ' 0 0 1 ' + (cx + r * Math.cos(a1)) + ' ' + (cy + r * Math.sin(a1)) + 'L' + (cx + ri * Math.cos(a1)) + ' ' + (cy + ri * Math.sin(a1)) + 'A' + ri + ' ' + ri + ' 0 0 0 ' + (cx + ri * Math.cos(a0)) + ' ' + (cy + ri * Math.sin(a0)) + 'Z';
      el('path', { d: d, fill: '#111' }, g);
    }
  }
  function draw() {
    if (!svg) return;
    var c = cur(); while (svg.firstChild) svg.removeChild(svg.firstChild);
    var cx = 500, cy = 300, R = 270, id = 'nf' + Math.random().toString(36).slice(2, 7), defs = el('defs', {}, svg);
    var f = el('filter', { id: id, x: '-15%', y: '-15%', width: '130%', height: '135%' }, defs);
    el('feDropShadow', { dx: 0, dy: 6, stdDeviation: 9, 'flood-color': '#000', 'flood-opacity': '.22' }, f);
    var mat = (optSel('Material') || {}).value || '', rigid = !/self-stick/i.test(mat);
    el('path', { d: 'M' + cx + ' ' + (cy - R) + 'L' + (cx + R) + ' ' + cy + 'L' + cx + ' ' + (cy + R) + 'L' + (cx - R) + ' ' + cy + 'Z', fill: '#fff', filter: 'url(#' + id + ')' }, svg);
    var q = [['M' + cx + ' ' + (cy - R) + 'L' + (cx + R / 2) + ' ' + (cy - R / 2) + 'L' + cx + ' ' + cy + 'L' + (cx - R / 2) + ' ' + (cy - R / 2) + 'Z', '#ED1C24'],
             ['M' + (cx - R) + ' ' + cy + 'L' + (cx - R / 2) + ' ' + (cy - R / 2) + 'L' + cx + ' ' + cy + 'L' + (cx - R / 2) + ' ' + (cy + R / 2) + 'Z', '#1474CC'],
             ['M' + (cx + R) + ' ' + cy + 'L' + (cx + R / 2) + ' ' + (cy - R / 2) + 'L' + cx + ' ' + cy + 'L' + (cx + R / 2) + ' ' + (cy + R / 2) + 'Z', '#FFF200'],
             ['M' + cx + ' ' + (cy + R) + 'L' + (cx + R / 2) + ' ' + (cy + R / 2) + 'L' + cx + ' ' + cy + 'L' + (cx - R / 2) + ' ' + (cy + R / 2) + 'Z', '#FFFFFF']];
    q.forEach(function (p) { el('path', { d: p[0], fill: p[1], stroke: '#111', 'stroke-width': 3, 'stroke-linejoin': 'round' }, svg); });
    el('path', { d: 'M' + cx + ' ' + (cy - R) + 'L' + (cx + R) + ' ' + cy + 'L' + cx + ' ' + (cy + R) + 'L' + (cx - R) + ' ' + cy + 'Z', fill: 'none', stroke: '#111', 'stroke-width': 5, 'stroke-linejoin': 'round' }, svg);
    function num(t, x, y) { var e = el('text', { x: x, y: y + R * .135, 'font-family': '"Arial Black", "Helvetica Neue", Arial, sans-serif', 'font-weight': 900, 'font-size': R * .4, 'text-anchor': 'middle', fill: '#111' }, svg); e.textContent = t; }
    num(c.f, cx, cy - R / 2); num(c.h, cx - R / 2, cy); num(c.i, cx + R / 2, cy);
    if (c.s === 'RAD') trefoil(svg, cx, cy + R / 2, R * .17);
    else if (c.s) {
      var fs = c.s.length > 3 ? R * .15 : (c.s.length > 2 ? R * .19 : R * .27);
      var e = el('text', { x: cx, y: cy + R / 2 + fs * .36, 'font-family': '"Arial Black", "Helvetica Neue", Arial, sans-serif', 'font-weight': 900, 'font-size': fs, 'text-anchor': 'middle', fill: '#111' }, svg); e.textContent = c.s;
      if (c.s === 'W') el('line', { x1: cx - fs * .75, x2: cx + fs * .75, y1: cy + R / 2, y2: cy + R / 2, stroke: '#111', 'stroke-width': fs * .09 }, svg);
    }
    if (rigid) [[cx, cy - R + 26], [cx + R - 26, cy], [cx, cy + R - 26], [cx - R + 26, cy]].forEach(function (p) { el('circle', { cx: p[0], cy: p[1], r: 6, fill: '#fff', stroke: '#111', 'stroke-width': 2 }, svg); });
    svg.setAttribute('viewBox', '0 0 1000 610');
  }
  function updateDiamond() {
    var c = cur(); draw();
    setProp('Health (Blue)', c.h); setProp('Flammability (Red)', c.f); setProp('Instability (Yellow)', c.i);
    var sl = ''; S.forEach(function (s) { if (s[0] === c.s) sl = s[0] ? s[1] : 'None'; }); setProp('Special (White)', sl);
    var sz = ($('ProductSelect-0') || {}).value || '', v = (cfg.view || {})[sz] || {};
    if ($('cm_nf_size')) $('cm_nf_size').textContent = sz.replace(/"/g, '”') || ' ';
    if ($('cm_nf_char')) $('cm_nf_char').textContent = v.ch || '—';
    if ($('cm_nf_dist')) $('cm_nf_dist').textContent = v.dist || '—';
    var mat = (optSel('Material') || {}).value || '', mi = (cfg.materials || {})[mat], box = $('cm_nf_mat');
    if (box) { if (mi) { box.innerHTML = '<b>' + mat + '</b><ul>' + mi.map(function (t) { return '<li>' + t + '</li>'; }).join('') + '</ul>'; box.style.display = ''; } else box.style.display = 'none'; }
  }
  function snapshot() {
    var uc = window.uploadcare, pk = window.UploadKit && window.UploadKit.config && window.UploadKit.config.ucKey;
    if (!uc || !uc.fileFrom || !pk || !svg) return Promise.resolve(null);
    return new Promise(function (ok) {
      var done = false, fin = function (v) { if (!done) { done = true; ok(v); } };
      setTimeout(function () { fin(null); }, 12000);
      try {
        var vb = svg.viewBox.baseVal, c = svg.cloneNode(true), Wp = 1000, Hp = Math.round(Wp * vb.height / vb.width);
        c.setAttribute('width', Wp); c.setAttribute('height', Hp);
        var img = new Image();
        img.onload = function () {
          var cv = document.createElement('canvas'); cv.width = Wp; cv.height = Hp;
          var ctx = cv.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, Wp, Hp); ctx.drawImage(img, 0, 0, Wp, Hp);
          cv.toBlob(function (bl) {
            if (!bl) return fin(null);
            uc.fileFrom('object', new File([bl], 'nfpa-diamond-preview.png', { type: 'image/png' }), { publicKey: pk })
              .done(function (info) { fin(info.cdnUrl + '-/preview/1200x1200/'); }).fail(function () { fin(null); });
          }, 'image/png');
        };
        img.onerror = function () { fin(null); };
        img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(c));
      } catch (e) { fin(null); }
    });
  }

  // ---------------- custom wording box ----------------
  var N = cfg.note || null;
  function buildNote() {
    var a = anchor(); if (!a || !N) return;
    var r = row(N.label || 'Custom wording', '<textarea id="nf_note" rows="3" maxlength="400" placeholder="' + (N.placeholder || '') + '"></textarea>', 'cm-nf-note d-none');
    a.parentElement.insertBefore(r, a);
    var m = document.createElement('div'); m.id = 'nf_note_msg'; m.className = 'cm-nf-msg d-none'; a.parentElement.insertBefore(m, a);
  }
  function noteOn() { if (!N) return false; var s = optSel(N.option); return !!s && s.value === N.value; }
  function updateNote() {
    if (!N) return; var on = noteOn(), r = document.querySelector('.cm-nf-note'), t = $('nf_note');
    if (r) r.classList.toggle('d-none', !on);
    setProp(N.prop || 'Custom Wording', on && t ? t.value.replace(/\s+/g, ' ').trim() : '');
    var m = $('nf_note_msg'); if (m && !on) m.className = 'cm-nf-msg d-none';
  }

  var pass = false;
  window.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest && ev.target.closest('#add_button');
    if (!btn) return;
    if (pass) { pass = false; return; }
    if (N && noteOn()) {
      updateNote(); var t = $('nf_note');
      if (t && !t.value.trim()) { ev.preventDefault(); ev.stopImmediatePropagation(); var m = $('nf_note_msg'); if (m) { m.className = 'cm-nf-msg bad'; m.textContent = N.required || 'Tell us the wording for your custom tags first.'; } t.focus(); return; }
    }
    if (!cfg.diamond) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    if (btn.classList.contains('cm-saving')) return;
    updateDiamond();
    var label = btn.innerHTML; btn.classList.add('cm-saving'); btn.innerHTML = 'Saving your sign…';
    snapshot().then(function (url) { setProp('Design Preview', url); btn.classList.remove('cm-saving'); btn.innerHTML = label; pass = true; btn.click(); });
  }, true);

  function init() {
    if (cfg.diamond && buildDiamond()) {
      document.addEventListener('change', function (e) { var t = e.target; if (t && (/^nf_[hfis]$/.test(t.id) || (t.classList && t.classList.contains('product_option_select')))) setTimeout(updateDiamond, 0); });
      updateDiamond(); setTimeout(updateDiamond, 600);
    }
    if (N) {
      buildNote();
      document.addEventListener('change', function (e) { var t = e.target; if (t && t.classList && t.classList.contains('product_option_select')) setTimeout(updateNote, 0); });
      document.addEventListener('input', function (e) { if (e.target && e.target.id === 'nf_note') { var m = $('nf_note_msg'); if (m) m.className = 'cm-nf-msg d-none'; updateNote(); } });
      updateNote(); setTimeout(updateNote, 600);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
